<template>

  <div class="login-container">
    <div class="container-login100">
      <div class="wrap-login100">
        <div class="login100-pic" data-tilt>
          <img :src="require('@/assets/sms-verify.jpeg')" alt="IMG" />
        </div>


        <el-form :model="form" status-icon :rules="formRules" ref="authForm">
            <span class="login90-form-title">2-Step Verification</span>
            <span class="login80-form-title">A text message with your code has been sent to your phone number.</span>
            <el-form-item prop="code" label="6-digit code">
              <el-input type="number" v-model="form.code" placeholder="Enter 6-digit code" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item>
              <div class="container-login100-form-btn">
                <el-button :loading="submiting" class="login100-form-btn" type="primary" @click="verifyCode()">Verify Code</el-button>
              </div>
            <div class="text-center p-t-12">
                <el-button type="text" @click="$router.push('/login')"> Go back to the sign in page</el-button>
			</div>
          </el-form-item>
        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
import {verifySMS} from '@/api/user'
export default {
    data(){
        return {
            submiting: false,
            form:{
                code: "",
                uid: this.$route.params.uid
            },
            formRules:{
                code: [{
                    required: true,
                    message: "Verification code required",
                    trigger: "blur",
                }]
            }
        }
    },
    methods:{
        verifyCode(){
            this.$refs.authForm.validate((valid)=>{
                if(valid){
                    this.submiting = true;

                    verifySMS(this.form).then(({result, data})=>{
                        this.submiting = false;
                        if(result && data.token){
                            this.$store.dispatch('user/setsession', data)
                            .then(() => {
                                this.$router.push('/')
                            })
                        }else{
                            if(data.redirectPage && data.redirectPage === '2fa') {
                                this.$router.push(`/login/two-factor-authentication/${data.uid}`)
                            }
                        }

                    })
                }
            })
        }
    }
}
</script>

<style lang="scss">
@import "~@/styles/login.scss";

</style>